{
  "instances": {
    "scheduledtasks": {
      "label": "排程任務",
      "no_scheduledtasks": "沒有排程任務。",
      "last_execution": "上次執行",
      "last_execution_status": "上次執行狀態",
      "next_execution": "下次執行",
      "cron": {
        "expression": "表達式",
        "runnable": "可執行項目",
        "title": "Cron"
      },

      "fixed_delay": {
        "initial_delay_ms": "初始延遲 (毫秒)",
        "interval_ms": "間隔 (毫秒)",
        "runnable": "可執行項目",
        "title": "Fixed Delay"
      },
      "fixed_rate": {
        "initial_delay_ms": "初始延遲 (毫秒)",
        "interval_ms": "間隔 (毫秒)",
        "runnable": "可執行項目",
        "title": "Fixed Rate"
      }
    }
  }
}
